import type {ChangeEventHandler, Dispatch, FC} from 'react';
import { type JSX, useCallback} from 'react'
import type {AnyRowData, DataTable_HeaderProps, DataTableState} from './dt-types'
import type {SelectChangeEventHandler} from '../vanilla/Select';
import Select from '../vanilla/Select'
import {PAGE_OPTIONS} from './dt-paginate'
import {ActionButtonIcon} from '../SaveSubmitButton'
import icons from '../../../markons/markons'
import {DtColumnConfig} from './dt-column-config'

export const DataTable_Length: FC<{ state: DataTableState, mergeState: Dispatch<Partial<DataTableState>> }> = ({
    state,
    mergeState
}) => {
    const setPageLength = useCallback<SelectChangeEventHandler<number>>(ev => mergeState({pageLength: ev.value}), [mergeState])

    return (
        <div className="dataTables_length">
            <label><Select<number> value={state.pageLength}
                onChange={setPageLength}
                options={PAGE_OPTIONS} /> rows</label>
        </div>
    )
}
const DataTable_Filter: FC<{ state: DataTableState, mergeState: Dispatch<Partial<DataTableState>> }> = ({
    state,
    mergeState
}) => {
    const setSearch = useCallback<ChangeEventHandler<HTMLInputElement>>(ev => {
        if(ev.target.value !== state.search) {
            mergeState({
                search: ev.target.value,
                startIndex: 0,
            })
        }
    }, [mergeState, state.search])

    return (
        <div className="dataTables_filter">
            <label>Search: <input type="search" value={state.search} onChange={setSearch} /></label>
        </div>
    )
}
export const DataTable_Header = <TRow extends AnyRowData, >({
    settings,
    state,
    mergeState,
    reload,
}: DataTable_HeaderProps<TRow>): JSX.Element => {
    return (
        <div className="dataTables_header dataTables_inputs">
            <div className="dataTables_header_block">
                <ActionButtonIcon className="dataTables_header_button"
                    icon={icons.ionRefresh}
                    onClick={reload}
                    /*disabled={state.isFetching}*/ />
                <DtColumnConfig {...{settings,state,mergeState}}/>
                {/*{settings.lengthChange ? <DataTable_Length state={state} mergeState={mergeState} /> : null}*/}
            </div>
            <div className="dataTables_header_block">
                {settings.searching ? <DataTable_Filter state={state} mergeState={mergeState} /> : null}
            </div>
        </div>
    )
}
